import Vue from 'vue'
import RegistrationForm from '~/components/composites/RegistrationForm'
import UserProfileForm from '~/components/composites/UserProfileForm'
import ForgotPasswordModal from '~/components/modals/ForgotPasswordModal'

window.Vue = Vue
Vue.mixin({
  comments: true,
  methods: {
    isSameGroupOrComponent(params, template) {
      if (this.getMainComponentId() === parseInt(params.componentId)) {
        if (params.groupId) {
          if (params.groupId === template.groupId) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },
    createVueTemplateComponent(template, data, j) {
      let retData = {}
      retData = Object.assign(retData, {
        env: process.env.env,
        datum: data[j],
        datumIndex: j,
        template: template,
        apiUrl: process.env.apiUrl
      })
      if (template.initialData) {
        retData = Object.assign(retData, template.initialData)
      }
      let menu = this.$route.path
      if (menu.lastIndexOf('/') >= 0) {
        menu = menu.substring(menu.lastIndexOf('/') + 1)
      }

      retData.menu = menu
      const state = window._globalVueParams.$store.state
      if (template.name === 'create-item-control') {
        retData.newItem = {
          i18n: {}
        }
        for (let i = 0; i < this.allLocales.length; i++) {
          retData.newItem.i18n[this.allLocales[i].value] = {}
        }
      } else if (template.name === 'update-item-control') {
        retData.item = data[j]
        for (let i = 0; i < this.allLocales.length; i++) {
          if (!retData.item.i18n[this.allLocales[i].value]) {
            retData.item.i18n[this.allLocales[i].value] = {}
          }
        }
      } else if (template.name.endsWith('-item')) {
        const key = template.name.substring(0, template.name.length - 5)
        const keyCamelCase = key.toCamelCase()
        retData.item = retData[key] = retData[keyCamelCase] = data[j]
        retData.size = template.size
        retData.totalSize = template.totalSize
        retData.loadedSize = template.loadedSize

        if (template.name === 'order-item') {
          retData.orderId = data[j].id
          retData.selectedOrder = undefined
          const order = retData.order
          const pc = order.amount * order.svc.commissionRate
          if (pc <= this.loggedInUser.point) {
            order.setleMthCode = 'settlement_method.point'
          } else {
            order.setleMthCode = 'settlement_method.creditcard'
          }
        } else if (template.name === 'goods-item') {
          retData.goodsId = data[j].id
        } else if (template.name === 'my-attended-lectures-item') {
          retData.atnlc = data[j]
          retData.goods = data[j].goods
          retData.setle = data[j].setle
        } else if (template.name === 'subscribed-channels-item') {
          retData.subscribe = data[j]
          retData.chnnel = data[j].chnnel
          retData.setle = data[j].setle
        } else if (template.name === 'my-purchases-item') {
          retData.goods = data[j]
        } else if (template.name === 'my-uploaded-item') {
          retData.goods = data[j]
        } else if (template.name === 'my-play-hist-item') {
          retData.playHist = data[j]
          retData.goods = data[j].atnlcComposition.goodsComposition.goods
          retData.goodsComposition = data[j].atnlcComposition.goodsComposition
        } else if (template.name === 'review-item') {
          retData.goodsId = data[j].goodsId
          retData.reviewId = data[j].id
        }
        retData.lastId = template.lastId
      } else if (template.name === 'locale-control') {
        if (state) {
          retData.locales = state.locales
        } else {
          retData.locales = []
        }
      } else if (
        template.name === 'more-items-control' ||
        template.name === 'load-on-scroll'
      ) {
        retData.size = template.size
        retData.totalSize = template.totalSize
        retData.loadedSize = template.loadedSize
        retData.lastId = template.lastId
      } else if (template.name === 'login-control') {
        retData.inputValType = 'email'
        retData.userId = ''
      } else if (template.name === 'player-control') {
        retData.goods = data[j]
        retData.newReview = { score: 5 }
        retData.nation = 'nation.kr'
        retData.showPlayer = true
        let currentComposition
        if (retData.goods && retData.goods.compositions) {
          for (let k = 0; k < retData.goods.compositions.length; k++) {
            const composition = retData.goods.compositions[k]
            if (
              composition.id === parseInt(this.$route.query.goodsCompositionId)
            ) {
              if (composition.atnlc) {
                currentComposition = composition
              }
              break
            }
          }
        }
        this.$eventHub.$emit('video-changed', {
          componentId: this.getMainComponentId(),
          composition: currentComposition,
          groupId: template.groupId
        })
      } else if (template.name === 'goods-display') {
        retData.goods = data[j]
        retData.selectedOptions = []
        retData.purchaseMode = false
        retData.newReview = { score: 5 }
        retData.myReview = retData.goods.reviewData.myReview
        if (retData.myReview) {
          retData.myReview.originalCn = retData.myReview.cn
          retData.myReview.originalScore = retData.myReview.score
        }
        retData.order = {
          setleMthCode: 'settlement_method.creditcard',
          pointToUse: 0,
          buyerNm: '',
          buyerTel: '',
          buyerEmail: '',
          endde: ''
        }
        if (this.loggedInUser) {
          retData.order.buyerNm = this.loggedInUser.nm
          if (window.isEmailFormat(this.loggedInUser.userId)) {
            retData.order.buyerEmail = this.loggedInUser.userId
          } else {
            retData.order.buyerTel = this.loggedInUser.userId
          }
          if (!retData.order.buyerEmail) {
            retData.order.buyerEmail = this.loggedInUser.email
          }
          if (!retData.order.buyerTel) {
            retData.order.buyerTel = this.loggedInUser.mobile
          }
        }
        /*
        const coResponse = await $.ajax({
          url: 'https://ip2c.org/s'
        })
        let browserNation = 'kr'
        if (coResponse) {
          const cos = coResponse.split(';')
          if (cos && cos.length > 1) {
            browserNation = cos[1].toLowerCase()
          }
        }
        retData.nation = 'nation.' + browserNation */
        retData.nation = 'nation.kr'
      } else if (template.name === 'channel-display') {
        retData.channel = data[j]
        retData.goodsList = []
        retData.totalSize = 0
        retData.lastId = undefined
        retData.goodsSearchText = ''
        retData.loadedSize = 0
        retData.purchaseMode = false
        retData.newReview = { score: 5 }
        retData.myReview = retData.channel.reviewData.myReview
        if (retData.myReview) {
          retData.myReview.originalCn = retData.myReview.cn
          retData.myReview.originalScore = retData.myReview.score
        }
        retData.order = {
          setleMthCode: 'settlement_method.creditcard',
          pointToUse: 0,
          buyerNm: '',
          buyerTel: '',
          buyerEmail: '',
          endde: ''
        }
        if (this.loggedInUser) {
          retData.order.buyerNm = this.loggedInUser.nm
          if (window.isEmailFormat(this.loggedInUser.userId)) {
            retData.order.buyerEmail = this.loggedInUser.userId
          } else {
            retData.order.buyerTel = this.loggedInUser.userId
          }
          if (!retData.order.buyerEmail) {
            retData.order.buyerEmail = this.loggedInUser.email
          }
          if (!retData.order.buyerTel) {
            retData.order.buyerTel = this.loggedInUser.mobile
          }
        }
        retData.nation = 'nation.kr'
      } else if (template.name === 'order-control') {
        if (!retData.order) {
          retData.order = {}
          retData.order.progrsMthCode = 'order_progress_method.first_come'
          retData.order.setleMthCode = 'settlement_method.point'
          retData.order.site = retData.initialSite
          retData.order.service = retData.initialService
          retData.order.nation = retData.initialNation
          retData.order.category = retData.initialCategory
        }
        if (!retData.order.additionalFieldData) {
          retData.order.additionalFieldData = {
            ctgry: {},
            order: {},
            orderer: {}
          }
        }
        retData.searchKeyword = ''
        if (!retData.categoryAdditionalFieldInfos) {
          retData.categoryAdditionalFieldInfos = []
        }
        if (!retData.orderAdditionalFieldInfos) {
          retData.orderAdditionalFieldInfos = []
        }
        if (!retData.ordererAdditionalFieldInfos) {
          retData.ordererAdditionalFieldInfos = []
        }
      } else if (template.name === 'offer-control') {
        if (!retData.offer) {
          retData.offer = {}
        } else {
          retData.offer.site = retData.initialSite
          retData.offer.service = retData.initialService
          retData.offer.nation = retData.initialNation
          retData.offer.category = retData.initialCategory
        }
        if (!retData.offer.additionalFieldData) {
          retData.offer.additionalFieldData = {
            offer: {}
          }
        }

        retData.searchKeyword = ''
        retData.offerAdditionalFieldInfos = undefined
      } else if (template.name === 'current-menu-display') {
        retData.currentMenuName = this.$t(
          'menu.nm.' + process.env.siteId + '.' + menu
        )
      } else if (template.name === 'no-items-display') {
        retData.hasData = true
      } else if (template.name.endsWith('-display')) {
        const itemName = template.name.substring(3, template.name.length - 8)
        retData[itemName] = data[j]
      } else if (template.name === 'login-control') {
        retData.userId = ''
        retData.userIdType = 'email'
      } else if (template.name === 'search-control') {
        retData.keyword = ''
      } else {
        retData.data = data[j]
      }
      if (template.name.endsWith('pagination-control')) {
        retData.currentPageNo = 0
        retData.totalPageNo = 0
        retData.size = 15
        retData.totalSize = 0
        retData.pages = []
        retData.diff = 3
        if (template.options && template.options.diff) {
          retData.diff = parseInt(template.options.diff)
        }
        retData.minPageNo = 0
        retData.maxPageNo = 0
      }
      if (template.name.endsWith('-item-detail')) {
        const itemName = template.name.substring(
          0,
          template.name.length - '-item-detail'.length
        )
        retData[itemName] = data[j]
        retData[itemName.toCamelCase()] = data[j]
      }

      if (
        window._templateComponents[template.name] &&
        window._templateComponents[template.name].data
      ) {
        const userDefinedData = window._templateComponents[template.name].data()
        retData = Object.assign(retData, userDefinedData)
      }

      const newVueComponentParam = {
        router: window._globalVueParams.$router,
        $i18n: window._globalVueParams.$i18n,
        $axios: window._globalVueParams.$axios,
        $auth: window._globalVueParams.$auth,
        $store: window._globalVueParams.$store,
        $toast: window._globalVueParams.$toast,
        components: {
          RegistrationForm,
          UserProfileForm,
          ForgotPasswordModal
        },
        data: function() {
          return retData
        },
        created() {
          if (!this.$store) {
            this.$store = window._globalVueParams.$store
          }
        },
        mounted() {
          const self = this
          $(this.$el)
            .find('a[href]')
            .each(function() {
              if (
                $(this).attr('target') &&
                $(this).attr('target') !== '_self'
              ) {
                return
              }
              if (!self.$router.totalRoutes) {
                return
              }
              const href = $(this).attr('href')
              let foundInRoutes = false
              for (let k = 0; k < self.$router.totalRoutes.length; k++) {
                const route = self.$router.totalRoutes[k]
                if (href.startsWith(route.path)) {
                  $(this).removeAttr('href')
                  $(this).on('click', e => {
                    self.openLink(href, e)
                  })
                  foundInRoutes = true
                  break
                }
              }
              if (!foundInRoutes) {
                $(this).attr('target', '_blank')
              }
            })
          if (template.name === 'order-control') {
            this.$eventHub.$on(
              'order-additional-field-info-loaded',
              this.onOrderAdditionalFieldInfoLoaded
            )
            this.$eventHub.$on(
              'orderer-additional-field-info-loaded',
              this.onOrdererAdditionalFieldInfoLoaded
            )
          }
          if (template.name === 'offer-control') {
            this.$eventHub.$on(
              'register-offer-additional-field-info-loaded',
              this.onRegisterOfferAdditionalFieldInfoLoaded
            )
          }
          if (template.name === 'order-item') {
            this.$eventHub.$on('order-received', this.onOrderReceived)
          }
          if (
            template.name === 'goods-display' ||
            template.name === 'channel-display'
          ) {
            this.$eventHub.$on('purchase-complete', this.onPurchaseComplete)
            this.$eventHub.$on('review-deleted', this.onReviewDeleted)
            this.$eventHub.$on('review-updated', this.onReviewUpdated)
          }
          if (template.name === 'channel-display') {
            this.$eventHub.$on('channel-subscribed', this.onChannelSubscribed)
            this.$eventHub.$on(
              'channel-unsubscribed',
              this.onChannelUnsubscribed
            )
            this.$eventHub.$on(
              'goods-loaded-on-channel',
              this.onGoodsLoadedOnChannel
            )
          }

          if (
            template.name === 'more-items-control' ||
            template.name === 'items-pagination-control' ||
            template.name === 'no-items-display' ||
            template.name === 'load-on-scroll'
          ) {
            this.$eventHub.$on('items-loaded', this.onItemsLoaded)
            this.$eventHub.$on(
              'items-page-info-loaded',
              this.onItemsPageInfoLoaded
            )
            this.$eventHub.$emit('show-me-items-page-info', {
              componentId: this.getMainComponentId(),
              groupId: template.groupId
            })
          }
          if (template.name === 'load-on-scroll') {
            if (!window._loadOnScroll) {
              $(window).on('scroll', this.onScrolling)
              window._loadOnScroll = true
            }
          }
        },
        beforeDestroy() {
          if (template.name === 'order-control') {
            this.$eventHub.$off(
              'order-additional-field-info-loaded',
              this.onOrderAdditionalFieldInfoLoaded
            )
            this.$eventHub.$off(
              'orderer-additional-field-info-loaded',
              this.onOrdererAdditionalFieldInfoLoaded
            )
          }
          if (template.name === 'order-item') {
            this.$eventHub.$off('order-received', this.onOrderReceived)
          }
          if (template.name === 'offer-control') {
            this.$eventHub.$off(
              'register-offer-additional-field-info-loaded',
              this.onRegisterOfferAdditionalFieldInfoLoaded
            )
          }
          if (
            template.name === 'goods-display' ||
            template.name === 'channel-display'
          ) {
            this.$eventHub.$off('purchase-complete', this.onPurchaseComplete)
            this.$eventHub.$off('review-deleted', this.onReviewDeleted)
            this.$eventHub.$off('review-updated', this.onReviewUpdated)
          }
          if (template.name === 'channel-display') {
            this.$eventHub.$off(
              'goods-loaded-on-channel',
              this.onGoodsLoadedOnChannel
            )
            this.$eventHub.$off('channel-subscribed', this.onChannelSubscribed)
            this.$eventHub.$off(
              'channel-unsubscribed',
              this.onChannelUnsubscribed
            )
          }
          if (
            template.name === 'more-items-control' ||
            template.name === 'items-pagination-control' ||
            template.name === 'no-items-display' ||
            template.name === 'load-on-scroll'
          ) {
            this.$eventHub.$off('items-loaded', this.onItemsLoaded)
            this.$eventHub.$off(
              'items-page-info-loaded',
              this.onItemsPageInfoLoaded
            )
          }
          if (template.name === 'load-on-scroll') {
            if (window._loadOnScroll) {
              $(window).off('scroll', this.onScrolling)
              window._loadOnScroll = false
            }
          }
        },
        methods: {
          onScrolling() {
            let loaderHeight = 0
            if (template.options && template.options.loaderHeight) {
              loaderHeight = template.options.loaderHeight
            }
            if (
              $(window).scrollTop() + $(window).height() >
              $(document).height() - loaderHeight
            ) {
              if (this.loadedSize < this.totalSize) {
                this.$eventHub.$emit('more-items-clicked', {
                  componentId: this.getMainComponentId(),
                  lastId: this.lastId,
                  groupId: template.groupId,
                  noLoading: true,
                  lastScrollTop: $(window).scrollTop()
                })
              }
            }
          },
          createGoods(e) {
            if (e) {
              e.stopPropagation()
              e.preventDefault()
            }
            this.$router.push({
              path: '/goods/create'
            })
          },
          canDeleteItem(item, itemName) {
            if (!this.hasAuthority('delete_' + itemName)) {
              return false
            }
            if (!this.loggedInUser && item.rgsOperId) {
              return false
            }
            if (this.loggedInUser && item.rgsOperId) {
              if (parseInt(item.rgsOperId) !== parseInt(this.loggedInUser.id)) {
                return false
              }
            }
            return true
          },
          canUpdateItem(item, itemName) {
            if (!this.hasAuthority('update_' + itemName)) {
              return false
            }
            if (!this.loggedInUser && item.rgsOperId) {
              return false
            }
            if (this.loggedInUser && item.rgsOperId) {
              if (parseInt(item.rgsOperId) !== parseInt(this.loggedInUser.id)) {
                return false
              }
            }
            return true
          },
          updateGoods(e, goods) {
            if (e) {
              e.stopPropagation()
              e.preventDefault()
            }
            this.$router.push({
              path: '/goods/update',
              query: { id: goods.id }
            })
          },
          getSettlementMethods(item) {
            const settlementMethods = []
            if (this.configs && item.settlementMethods) {
              for (let j = 0; j < item.settlementMethods.length; j++) {
                const settlementMethod = item.settlementMethods[j]
                if (
                  this.configs.settlement_methods &&
                  this.configs.settlement_methods.length > 0
                ) {
                  for (
                    let i = 0;
                    i < this.configs.settlement_methods.length;
                    i++
                  ) {
                    const settlementMethodOption = this.configs
                      .settlement_methods[i].value
                    if (settlementMethodOption === settlementMethod.code) {
                      settlementMethods.push(settlementMethod)
                      break
                    }
                  }
                  if (
                    settlementMethod.code === 'settlement_method.point' &&
                    this.configs &&
                    this.configs.use_point &&
                    this.configs.use_point !== 'false'
                  ) {
                    settlementMethods.push(settlementMethod)
                  }
                }
              }
            }
            return settlementMethods
          },
          getSettlementMethodsRealThing(item) {
            const settlementMethods = []
            if (this.configs && item.settlementMethods) {
              for (let j = 0; j < item.settlementMethods.length; j++) {
                const settlementMethod = item.settlementMethods[j]
                if (
                  this.configs.settlement_methods_real_thing &&
                  this.configs.settlement_methods_real_thing.length > 0
                ) {
                  for (
                    let i = 0;
                    i < this.configs.settlement_methods_real_thing.length;
                    i++
                  ) {
                    const settlementMethodOption = this.configs
                      .settlement_methods_real_thing[i].value
                    if (settlementMethodOption === settlementMethod.code) {
                      this.addSettleMethod(
                        settlementMethods,
                        settlementMethod,
                        item
                      )
                      break
                    }
                  }
                  if (
                    settlementMethod.code === 'settlement_method.point' &&
                    this.configs &&
                    this.configs.use_point &&
                    this.configs.use_point !== 'false'
                  ) {
                    this.addSettleMethod(
                      settlementMethods,
                      settlementMethod,
                      item
                    )
                  }
                }
              }
            }
            return settlementMethods
          },
          addSettleMethod(settlementMethods, settlementMethod, item) {
            if (!item.customSetleMthFlag || item.customSetleMthFlag === 'N') {
              settlementMethods.push(settlementMethod)
              return
            }
            for (let i = 0; i < item.setleMthList.length; i++) {
              const setleMthItem = item.setleMthList[i]
              console.log(setleMthItem.setleMthCode, settlementMethod.code)
              if (setleMthItem.setleMthCode === settlementMethod.code) {
                settlementMethods.push(settlementMethod)
                return
              }
            }
            return settlementMethods
          },
          hasNotPurchasedCompositions(compositions) {
            if (!compositions || compositions.length === 0) {
              return false
            }
            for (let i = 0; i < compositions.length; i++) {
              if (!compositions[i].atnlc) {
                return true
              }
            }
            return false
          },
          onChangePointToUse(e, item) {
            this.checkPointToUse(item)
          },
          onChangeSettlementMethod() {
            if (this.order.setleMthCode === 'settlement_method.point') {
              this.order.pointToUse = this.goods.point
            } else {
              this.order.pointToUse = 0
            }
            this.$forceUpdate()
          },
          checkPointToUse(item) {
            if (this.order.pointToUse > this.loggedInUser.point) {
              this.order.pointToUse = this.loggedInUser.point
            }
            if (this.getCalculatedPoint(item) < this.order.pointToUse) {
              this.order.pointToUse = this.getCalculatedPoint(item)
              this.order.setleMthCode = 'settlement_method.point'
            }
            this.$forceUpdate()
          },
          useAllPoints(item) {
            this.order.pointToUse = this.loggedInUser.point
              ? this.loggedInUser.point
              : 0
            this.checkPointToUse(item)
          },
          getScorePercentage(item, count) {
            if (!item || !item.reviewData || !item.reviewData.scoreData) {
              return 0
            }
            let total = 0
            total += item.reviewData.scoreData.score1Count
            total += item.reviewData.scoreData.score2Count
            total += item.reviewData.scoreData.score3Count
            total += item.reviewData.scoreData.score4Count
            total += item.reviewData.scoreData.score5Count
            if (total === 0) {
              return 0
            }
            return (100 * count) / total
          },
          saveItemConfirm(e, item) {
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.$eventHub.$emit('save-item-confirm', {
                  item: item,
                  bbs: this.bbs,
                  componentId: this.getMainComponentId(),
                  groupId: template.groupId
                })
              })
            })
          },
          purchaseConfirm(e, order, item, selectedOptions) {
            if (
              (!item.pc || item.mainItemPurchased) &&
              (!selectedOptions || selectedOptions.length === 0)
            ) {
              this.$toast.error(
                this.$t('settlement.text.no_selected_adit_options')
              )
              return
            }
            const self = this
            $(this.$el)
              .find('[data-vv-as]')
              .each(function() {
                self.$validator.validate($(this).attr('name'))
              })
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.$eventHub.$emit('purchase-confirm', {
                  order: order,
                  item: item,
                  nation: this.nation,
                  totalAmount: this.getTotalAmount(item),
                  amount: this.getCalculatedAmount(item),
                  point: this.getCalculatedPoint(item),
                  options: selectedOptions,
                  componentId: this.getMainComponentId(),
                  groupId: template.groupId
                })
              })
            })
          },
          onPurchaseComplete(params) {
            if (this.isSameGroupOrComponent(params, template)) {
              this.purchaseMode = false
              this[params.itemName] = params.item
            }
          },
          deleteReviewConfirm(e, item, review) {
            this.$eventHub.$emit('delete-review-confirm', {
              review: review,
              item: item,
              componentId: this.getMainComponentId(),
              groupId: template.groupId
            })
          },
          updateReviewConfirm(e, item, review) {
            review.reviewTrgtId = item.id
            this.$eventHub.$emit('update-review-confirm', {
              review: review,
              item: item,
              componentId: this.getMainComponentId(),
              groupId: template.groupId
            })
          },
          onReviewDeleted(params) {
            if (this.isSameGroupOrComponent(params, template)) {
              const item = params.item
              if (item && item.reviewData) {
                if (item.reviewData.list) {
                  for (let i = 0; i < item.reviewData.list.length; i++) {
                    const review = item.reviewData.list[i]
                    if (params.review.id === review.id) {
                      item.reviewData.list.splice(i, 1)
                      item.reviewData.totalSize--
                      item.reviewData.loadedSize--
                      break
                    }
                  }
                }
                if (item.reviewData.myReview) {
                  if (params.review.id === item.reviewData.myReview.id) {
                    delete item.reviewData.myReview
                    this.myReview = undefined
                  }
                }
                item.reviewData.scoreData = params.scoreData
              }
            }
          },
          onReviewUpdated(params) {
            if (this.isSameGroupOrComponent(params, template)) {
              const item = params.item
              item.reviewData.scoreData = params.reviewData.scoreData
              this.myReview = params.reviewData.myReview
              if (this.myReview) {
                this.myReview.originalCn = this.myReview.cn
                this.myReview.originalScore = this.myReview.score
              }
              if (item.reviewData.list && item.reviewData.list.length > 0) {
                for (let i = 0; i < item.reviewData.list.length; i++) {
                  const reviewItem = item.reviewData.list[i]
                  if (reviewItem.id === this.myReview.id) {
                    reviewItem.cn = this.myReview.cn
                    reviewItem.score = this.myReview.score
                  }
                }
              }
              this.$forceUpdate()
            }
          },
          showReference: function(obj) {
            obj.showReference = true
            this.$forceUpdate()
          },
          hideReference: function(obj) {
            obj.showReference = false
            this.$forceUpdate()
          },
          isPaidChannel: function(goods) {
            const channel = this.getPaidChannel(goods)
            if (channel) {
              return true
            }
            return false
          },
          isUploader: function(rgsOperId, user) {
            return rgsOperId === user.id
          },
          getPaidChannel: function(goods) {
            if (goods.channels && goods.channels.length > 0) {
              if (goods.paidChannels && goods.paidChannels.length > 0) {
                for (let i = 0; i < goods.channels.length; i++) {
                  for (let j = 0; j < goods.paidChannels.length; j++) {
                    if (goods.channels[i].id === goods.paidChannels[j].id) {
                      return goods.channels[i]
                    }
                  }
                }
              }
            }
            return null
          },
          viewMoreReviews: function(e, reviewTrgtTyCode, reviewTrgt) {
            e.stopPropagation()
            e.preventDefault()

            const lastIndex = reviewTrgt.reviewData.list.length - 1
            const lastId = reviewTrgt.reviewData.list[lastIndex].id
            this.$axios
              .$get(
                'review/public/review?reviewTrgtTyCode=' +
                  reviewTrgtTyCode +
                  '&reviewTrgtId=' +
                  reviewTrgt.id +
                  '&size=5&withContents=true&lastId=' +
                  lastId
              )
              .then(response => {
                if (response.resultCode === 'success') {
                  const copiedData = window.copyObject(response.data)
                  copiedData.list = reviewTrgt.reviewData.list.concat(
                    copiedData.list
                  )
                  reviewTrgt.reviewData = copiedData
                  this.$forceUpdate()
                } else {
                  console.error(this.$t(response.message, response.params))
                  this.$toast.error(this.$t(response.message, response.params))
                }
              })
          },
          addReview: function(e, reviewTrgtTyCode, reviewTrgt, review) {
            e.stopPropagation()
            e.preventDefault()
            review.reviewTrgtId = reviewTrgt.id
            review.reviewTrgtTyCode = reviewTrgtTyCode
            this.$axios.$post('review/addReview', review).then(response => {
              if (response.resultCode === 'success') {
                reviewTrgt.reviewData = response.data
                this.myReview = reviewTrgt.reviewData.myReview
                if (this.myReview) {
                  this.myReview.originalCn = this.myReview.cn
                  this.myReview.originalScore = this.myReview.score
                }
                this.newReview = {
                  title: '',
                  cn: '',
                  score: 5
                }
                this.$forceUpdate()
              } else {
                console.error(this.$t(response.message, response.params))
                this.$toast.error(this.$t(response.message, response.params))
              }
            })
          },
          showPurchaseDetail(e) {
            e.stopPropagation()
            e.preventDefault()
            if (!this.checkLogin()) {
              return
            }
            this.purchaseMode = !this.purchaseMode
          },
          subscribeChannel(e, channel) {
            e.stopPropagation()
            e.preventDefault()
            if (!this.checkLogin()) {
              return
            }
            this.$eventHub.$emit('subscribe-channel-confirm', {
              channel: channel,
              componentId: this.getMainComponentId(),
              groupId: template.groupId
            })
          },
          unsubscribeChannel(e, channel) {
            e.stopPropagation()
            e.preventDefault()
            if (!this.checkLogin()) {
              return
            }
            this.$eventHub.$emit('unsubscribe-channel-confirm', {
              channel: channel,
              componentId: this.getMainComponentId(),
              groupId: template.groupId
            })
          },
          onChannelSubscribed(params) {
            if (this.isSameGroupOrComponent(params, template)) {
              this.channel.subscribe = params.subscribe
              this.$forceUpdate()
            }
          },
          onChannelUnsubscribed(params) {
            if (this.isSameGroupOrComponent(params, template)) {
              delete this.channel.subscribe
              this.$forceUpdate()
            }
          },
          getOptionValue(option) {
            return {
              id: option.id,
              ehgt: option.ehgt
            }
          },
          getTotalAmount(item) {
            let amount = 0
            if (!item.mainItemPurchased) {
              amount += item.pc
            }
            if (item.compositions && item.compositions.length > 0) {
              for (let i = 0; i < item.compositions.length; i++) {
                const composition = item.compositions[i]
                if (
                  composition.optnFlag === 'Y' &&
                  composition.exchangedPrice
                ) {
                  if (this.selectedOptions && this.selectedOptions.length > 0) {
                    for (let j = 0; j < this.selectedOptions.length; j++) {
                      if (composition.id === this.selectedOptions[j].id) {
                        amount += composition.exchangedPrice
                        break
                      }
                    }
                  }
                }
              }
            }
            return amount
          },
          getCalculatedAmount(item) {
            let amount = this.getTotalAmount(item)
            if (item && item.exchangeRate) {
              amount = amount - this.order.pointToUse * item.exchangeRate.ehgt
            }
            return amount
          },
          getCalculatedPoint(item) {
            if (!item) return 0
            let amount = item.point
            if (item.compositions && item.compositions.length > 0) {
              for (let i = 0; i < item.compositions.length; i++) {
                const composition = item.compositions[i]
                if (composition.optnFlag === 'Y' && composition.point) {
                  if (this.selectedOptions && this.selectedOptions.length > 0) {
                    for (let j = 0; j < this.selectedOptions.length; j++) {
                      if (composition.id === this.selectedOptions[j].id) {
                        amount += composition.point
                        break
                      }
                    }
                  }
                }
              }
            }
            return amount
          },
          isSeller: function(sellers, user) {
            if (sellers && sellers.length > 0 && user) {
              for (let i = 0; i < sellers.length; i++) {
                if (sellers[i].id === user.id) {
                  return true
                }
              }
            }
            return false
          },
          playComposition(goods, composition) {
            if (!this.checkLogin()) {
              return
            }
            let url =
              '/goods/player?goodsId=' +
              goods.id +
              '&goodsCompositionId=' +
              composition.id +
              '&hasNoDefaultLayout=true'
            if (composition.atnlc) {
              url += '&atnlcCompositionId=' + composition.atnlc.id
            }
            window.open(
              url,
              'lineedu_player',
              'width=500,height=700,menubar=no,location=no,resizable=no,status=no'
            )
          },
          onForceUpdate() {
            this.$forceUpdate()
          },
          gotoMenu(e, menu, gotoFirstChildMenu, callback) {
            e.stopPropagation()
            e.preventDefault()
            if (window.onEvent['menu-clicked']) {
              window.onEvent['menu-clicked'](menu, e)
            }
            if (menu.link) {
              this.openLink(menu.link, e)
              return
            }
            if (!menu.parentPath) {
              menu.parentPath = ''
            }
            if (!menu.module) {
              if (menu.children && menu.children.length > 0) {
                if (gotoFirstChildMenu) {
                  this.gotoMenu(e, menu.children[0], gotoFirstChildMenu)
                  return
                }
              }
              if (callback) {
                callback(e, menu)
              }
              return
            }
            if (callback) {
              callback(e, menu)
            }
            let menuPath = menu.parentPath + '/'
            menuPath += menu.menu

            this.vibrate()
            if (menuPath === this.$router.currentRoute.fullPath) {
              this.$router.replace('/tmp')
              const self = this
              setTimeout(function() {
                self.$router.replace(menuPath)
              }, 10)
            } else {
              this.$router.push(menuPath)
            }
          },
          openBbsctt(path, bbsctt, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: path,
              query: { id: bbsctt.id }
            })
          },
          openGoods(goods, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: '/goods',
              query: { id: goods.id }
            })
          },
          openChannel(channel, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: '/channel/' + channel.alias
            })
          },
          getAttachmentImage(bbsctt, defaultImage, width) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            if (bbsctt && bbsctt.attachments && bbsctt.attachments.length > 0) {
              for (let i = 0; i < bbsctt.attachments.length; i++) {
                if (
                  bbsctt.attachments[i].fileMimeTy &&
                  bbsctt.attachments[i].fileMimeTy.startsWith('image/')
                ) {
                  return this.getImgUrl(bbsctt.attachments[i], width)
                }
              }
            }
            return defaultImage
          },
          hasAttachmentImage(bbsctt) {
            if (bbsctt && bbsctt.attachments && bbsctt.attachments.length > 0) {
              for (let i = 0; i < bbsctt.attachments.length; i++) {
                if (
                  bbsctt.attachments[i].fileMimeTy &&
                  bbsctt.attachments[i].fileMimeTy.startsWith('image/')
                ) {
                  return true
                }
              }
            }
            return false
          },
          getAttachmentImages(item, fieldName, defaultImage, width) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            const images = []
            if (item[fieldName] && item[fieldName].length > 0) {
              for (let i = 0; i < item[fieldName].length; i++) {
                if (
                  item[fieldName][i].fileMimeTy &&
                  item[fieldName][i].fileMimeTy.startsWith('image/')
                ) {
                  images.push(this.getImgUrl(item[fieldName][i], width))
                }
              }
            }
            if (images.length === 0) {
              images.push(defaultImage)
            }
            return images
          },
          getThumbImage(obj, defaultImage, width) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            if (obj && obj.thumbs && obj.thumbs.length > 0) {
              for (let i = 0; i < obj.thumbs.length; i++) {
                if (
                  obj.thumbs[i].fileMimeTy &&
                  obj.thumbs[i].fileMimeTy.startsWith('image/')
                ) {
                  return this.getImgUrl(obj.thumbs[i], width)
                }
              }
            }
            return defaultImage
          },
          hasThumbImage(obj) {
            if (obj && obj.thumbs && obj.thumbs.length > 0) {
              for (let i = 0; i < obj.thumbs.length; i++) {
                if (
                  obj.thumbs[i].fileMimeTy &&
                  obj.thumbs[i].fileMimeTy.startsWith('image/')
                ) {
                  return true
                }
              }
            }
            return false
          },
          getIconImage(obj, defaultImage, width) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            if (obj && obj.icons && obj.icons.length > 0) {
              for (let i = 0; i < obj.icons.length; i++) {
                if (
                  obj.icons[i].fileMimeTy &&
                  obj.icons[i].fileMimeTy.startsWith('image/')
                ) {
                  return this.getImgUrl(obj.icons[i], width)
                }
              }
            }
            return defaultImage
          },
          getIconImageWithObjectId(
            tableNm,
            tableKey,
            filePurpose,
            order,
            defaultImage,
            width,
            extendedParams
          ) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            return this.getImgUrlWithObjectId(
              tableNm,
              tableKey,
              filePurpose,
              order,
              defaultImage,
              width,
              undefined,
              undefined,
              extendedParams
            )
          },
          getBannerImage(obj, defaultImage, width) {
            if (!defaultImage) {
              defaultImage = '/img/thumb/defaultPicture.png'
            }

            if (obj && obj.banners && obj.banners.length > 0) {
              for (let i = 0; i < obj.banners.length; i++) {
                if (
                  obj.banners[i].fileMimeTy &&
                  obj.banners[i].fileMimeTy.startsWith('image/')
                ) {
                  return this.getImgUrl(obj.banners[i], width)
                }
              }
            }
            return defaultImage
          },
          getValueType(code) {
            if (code.startsWith('value_type.')) {
              return code.replace('value_type.', '')
            }
            return code
          },
          getFileInfo(datum) {
            if (
              this.getValueType(datum.valueTyCode) === 'singlefile' ||
              this.getValueType(datum.valueTyCode) === 'multifile'
            ) {
              return datum.optn.fileInfo
            }
            return undefined
          },
          getOptions(datum) {
            if (
              !datum ||
              !datum.optn ||
              !datum.optn.options ||
              datum.optn.options.length === 0
            ) {
              return null
            }

            const options = []
            for (let i = 0; i < datum.optn.options.length; i++) {
              const option = datum.optn.options[i]
              if (datum.optn.multilanguage) {
                options.push({
                  value: option.value,
                  text: this.$t(option.text[0].code)
                })
              } else {
                options.push({
                  value: option.value,
                  text: option.text
                })
              }
            }

            return options
          },
          hasError(name) {
            return this.errors.has(name)
          },
          onInputVueTelInput(p1, p2) {
            if (p2 && p2.number && p2.number.international) {
              this.userId = p2.number.international
            }
          },
          openMediaChnnel(mediaChnnel, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: '#mediaChannel',
              query: { id: mediaChnnel.id }
            })
          },
          openMediaAll(mediaChnnel, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: '#mediaChannelVideoAll',
              query: { id: mediaChnnel.id }
            })
          },
          openMedia(media, e) {
            e.stopPropagation()
            e.preventDefault()
            this.$router.push({
              path: '#mediaShowVideo',
              query: { id: media.id }
            })
          }
        },
        template: template.html
      }
      if (template.name === 'order-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            onSearchServiceEnter(e) {
              if (e && e.keyCode === 13) {
                this.searchService(e)
              }
            },
            onOrderAdditionalFieldInfoLoaded(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                this.categoryAdditionalFieldInfos =
                  params.categoryAdditionalFieldInfos
                this.orderAdditionalFieldInfos =
                  params.orderAdditionalFieldInfos
                this.$forceUpdate()
              }
            },
            onOrdererAdditionalFieldInfoLoaded(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                this.ordererAdditionalFieldInfos =
                  params.ordererAdditionalFieldInfos
              }
            },
            async gotoNextOrderStep() {
              if (!(await this.validateUnder(this.$el))) {
                return
              }

              this.$eventHub.$emit('goto-next-order-step', {
                order: this.order,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            gotoPrevOrderStep() {
              this.$eventHub.$emit('goto-prev-order-step', {
                order: this.order,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            completeOrder() {
              this.$eventHub.$emit('complete-order', {
                order: this.order,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            searchService(e) {
              if (e) {
                e.stopPropagation()
                e.preventDefault()
              }
              this.order.site = undefined
              this.order.service = undefined
              this.order.category = undefined
              this.services = []
              this.categories = []
              if (e) {
                this.$axios
                  .$get(
                    '/order/searchService?searchKeyword=' + this.searchKeyword
                  )
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < this.sites.length; i++) {
                        if (
                          this.sites[i].value === response.data.selectedSite
                        ) {
                          this.order.site = this.sites[i]
                          break
                        }
                      }
                      for (let i = 0; i < response.data.svcs.length; i++) {
                        const service = {
                          text: this.$t('svc.nm.' + response.data.svcs[i].id),
                          value: response.data.svcs[i].id,
                          data: response.data.svcs[i]
                        }
                        if (service.value === response.data.selectedSvc) {
                          this.order.service = service
                        }
                        this.services.push(service)
                      }
                      this.services.sort(window.sortFunction)
                      for (
                        let i = 0;
                        i < response.data.categories.length;
                        i++
                      ) {
                        const category = {
                          text: this.$t(
                            'ctgry.nm.' +
                              response.data.categories[i].site.id +
                              '.' +
                              response.data.categories[i].id
                          ),
                          value: response.data.categories[i].id
                        }
                        if (response.data.categories.length === 1) {
                          this.order.category = category
                        }
                        this.categories.push(category)
                      }
                      this.categories.sort(window.sortFunction)
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            },
            onOrderControlSiteChanged(e) {
              this.order.service = undefined
              this.order.category = undefined
              this.services = []
              this.categories = []
              if (e) {
                this.$axios
                  .$get('/svc/public/getServices?siteId=' + e.value)
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < response.data.length; i++) {
                        const service = {
                          text: this.$t('svc.nm.' + response.data[i].id),
                          value: response.data[i].id,
                          data: response.data[i]
                        }
                        this.services.push(service)
                        if (response.data.length === 1) {
                          this.order.service = service
                        }
                      }
                      this.services.sort(window.sortFunction)
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            },
            onOrderControlServiceChanged(e) {
              this.categories = []
              this.categoryAdditionalFieldInfos = []
              this.order.additionalFieldData.order = {}
              this.order.additionalFieldData.orderer = {}
              this.order.additionalFieldData.ctgry = {}
              this.order.category = undefined
              if (e) {
                this.$axios
                  .$get('/ctgry/public/getCategories?svcId=' + e.value)
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < response.data.length; i++) {
                        const category = {
                          text: this.$t(
                            'ctgry.nm.' +
                              response.data[i].site.id +
                              '.' +
                              response.data[i].id
                          ),
                          value: response.data[i].id
                        }
                        this.categories.push(category)
                        if (i === 0) {
                          this.order.category = category
                        }
                      }

                      this.categories.sort(window.sortFunction)
                      this.$forceUpdate()
                      this.$nextTick(() => {
                        this.$eventHub.$emit('order-control-category-changed', {
                          componentId: this.getMainComponentId(),
                          category: this.order.category,
                          groupId: template.groupId
                        })
                      })
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            },
            onOrderControlCategoryChanged(e) {
              this.$eventHub.$emit('order-control-category-changed', {
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            }
          }
        )
      } else if (template.name === 'offer-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            onSearchServiceEnter(e) {
              if (e && e.keyCode === 13) {
                this.searchService(e)
              }
            },
            onRegisterOfferAdditionalFieldInfoLoaded(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                this.offerAdditionalFieldInfos =
                  params.offerAdditionalFieldInfos
              }
            },
            gotoNextOfferStep() {
              this.$eventHub.$emit('goto-next-register-offer-step', {
                offer: this.offer,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            gotoPrevOfferStep() {
              this.$eventHub.$emit('goto-prev-register-offer-step', {
                offer: this.offer,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            completeOffer() {
              this.$eventHub.$emit('complete-register-offer', {
                offer: this.offer,
                categories: this.categories,
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            },
            onOfferControlServiceChanged(e) {
              this.offer.category = undefined
              this.categories = []
              if (e) {
                this.$axios
                  .$get('/ctgry/public/getCategories?svcId=' + e.value)
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < response.data.length; i++) {
                        const category = {
                          text: this.$t(
                            'ctgry.nm.' +
                              response.data[i].site.id +
                              '.' +
                              response.data[i].id
                          ),
                          value: response.data[i].id
                        }
                        this.categories.push(category)
                        if (response.data.length === 1) {
                          this.offer.category = category
                        }
                      }
                      this.categories.sort(window.sortFunction)
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            },
            searchService(e) {
              if (e) {
                e.stopPropagation()
                e.preventDefault()
              }
              this.offer.site = undefined
              this.offer.service = undefined
              this.services = []
              this.categories = []
              if (e) {
                this.$axios
                  .$get(
                    '/offer/searchService?searchKeyword=' + this.searchKeyword
                  )
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < this.sites.length; i++) {
                        if (
                          this.sites[i].value === response.data.selectedSite
                        ) {
                          this.offer.site = this.sites[i]
                          break
                        }
                      }
                      for (let i = 0; i < response.data.svcs.length; i++) {
                        const service = {
                          text: this.$t('svc.nm.' + response.data.svcs[i].id),
                          value: response.data.svcs[i].id,
                          data: response.data.svcs[i]
                        }
                        if (service.value === response.data.selectedSvc) {
                          this.offer.service = service
                        }
                        this.services.push(service)
                      }
                      this.services.sort(window.sortFunction)
                      for (
                        let i = 0;
                        i < response.data.categories.length;
                        i++
                      ) {
                        const category = {
                          text: this.$t(
                            'ctgry.nm.' +
                              response.data.categories[i].site.id +
                              '.' +
                              response.data.categories[i].id
                          ),
                          value: response.data.categories[i].id
                        }
                        if (response.data.categories.length === 1) {
                          this.offer.category = category
                        }
                        this.categories.push(category)
                      }
                      this.categories.sort(window.sortFunction)
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            },
            onOfferControlSiteChanged(e) {
              this.offer.service = undefined
              this.categories = []
              this.services = []
              if (e) {
                this.$axios
                  .$get('/svc/public/getServices?siteId=' + e.value)
                  .then(response => {
                    if (response.resultCode === 'success') {
                      for (let i = 0; i < response.data.length; i++) {
                        const service = {
                          text: this.$t('svc.nm.' + response.data[i].id),
                          value: response.data[i].id,
                          data: response.data[i]
                        }
                        this.services.push(service)
                        if (response.data.length === 1) {
                          this.offer.service = service
                        }
                      }
                      this.services.sort(window.sortFunction)
                    } else {
                      console.error(this.$t(response.message))
                      this.$toast.error(this.$t(response.message))
                    }
                  })
              }
            }
          }
        )
      } else if (template.name === 'my-attended-lectures-item') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            deleteAtnlc(atnlc, e) {
              e.preventDefault()
              e.stopPropagation()
              if (atnlc.setle) {
                this.$toast.info(
                  this.$t('atnlc.notification.deletable_lecture')
                )
                return
              }
              this.$eventHub.$emit('delete-atnlc-confirm', {
                componentId: this.getMainComponentId(),
                atnlc: atnlc,
                groupId: template.groupId
              })
            }
          }
        )
      } else if (template.name === 'subscribed-channels-item') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            deleteSubscribe(subscribe, e) {
              e.preventDefault()
              e.stopPropagation()
              if (subscribe.setle) {
                this.$toast.info(
                  this.$t('subscribe.notification.deletable_channel')
                )
                return
              }
              this.$eventHub.$emit('delete-subscribe-confirm', {
                componentId: this.getMainComponentId(),
                subscribe: subscribe,
                groupId: template.groupId
              })
            }
          }
        )
      } else if (template.name === 'channel-display') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            onGoodsLoadedOnChannel(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                if (params.goods) {
                  if (!this.goodsList) {
                    this.goodsList = []
                  }
                  this.goodsList = this.goodsList.concat(params.goods)
                  this.totalSize = params.totalSize
                  this.loadedSize += params.loadedSize
                  this.$forceUpdate()
                }
              }
            },
            moreGoods() {
              this.$eventHub.$emit('more-goods', {
                componentId: this.getMainComponentId(),
                groupId: template.groupId
              })
            }
          }
        )
      } else if (template.name.endsWith('-pagination-control')) {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            clickPage(e, pageNo) {
              e.preventDefault()
              e.stopPropagation()
              this.$eventHub.$emit('items-page-clicked', {
                componentId: this.getMainComponentId(),
                pageNo: pageNo,
                groupId: template.groupId
              })
            }
          }
        )
      } else if (
        template.name === 'more-items-control' ||
        template.name === 'load-on-scroll'
      ) {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            more(e, lastId) {
              e.preventDefault()
              e.stopPropagation()
              this.$eventHub.$emit('more-items-clicked', {
                componentId: this.getMainComponentId(),
                lastId: lastId,
                groupId: template.groupId
              })
            }
          }
        )
      } else if (
        template.name === 'order-item' ||
        template.name === 'order-display'
      ) {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            onOrderReceived(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                if (parseInt(this.orderId) === parseInt(params.order.id)) {
                  $(this.$el).remove()
                }
              }
            },
            onSettlementMethodChanged(e) {
              this.$nextTick(() => {
                this.$forceUpdate()
              })
            },
            gotoNextReceiveStep(order) {
              let validated = true
              const self = this
              $(this.$el)
                .find(
                  '.additional-receive-info-area input[required],.additional-receive-info-area select[required],.additional-receive-info-area textarea[required]'
                )
                .each(function() {
                  if (!$(this).val() || $(this).val().length === 0) {
                    validated = false
                    self.$toast.error(
                      self.$t('validation.message.required', {
                        field: $(this).attr('placeholder')
                      })
                    )
                    $(this).focus()
                  }
                  if (!validated) {
                    return false
                  }
                })
              if (validated) {
                $(this.$el)
                  .find('.additional-receive-info-area .show-invalid')
                  .each(function() {
                    validated = false
                    self.$toast.error($(this).text())
                    $(this)
                      .closest('.input-control')
                      .find('input,select,textarea')
                      .focus()
                    return false
                  })
              }
              if (validated) {
                order.receiveStep = 'step2'
                this.$forceUpdate()
              }
            },
            gotoPreviousReceiveStep(order) {
              order.receiveStep = 'step1'
              this.$forceUpdate()
            },
            receive(order) {
              order.receiveModalOpened = true
              order.receiveStep = 'step1'
              this.oldHtmlOverflowCss = $('html').css('overflow')
              $('html').css('overflow', 'hidden')
              $('.receive-order-area[order-id=' + order.id + ']').fadeIn(
                400,
                'linear'
              )
              this.$forceUpdate()
            },
            doReceiveConfirm(order) {
              const self = this
              $(this.$el)
                .find('[data-vv-as]')
                .each(function() {
                  self.$validator.validate($(this).attr('name'))
                })
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.$eventHub.$emit('do-receive-confirm', {
                    order: order,
                    amount: (order.amount * order.svc.commissionRate) / 100,
                    componentId: this.getMainComponentId(),
                    groupId: template.groupId
                  })
                })
              })
            },
            getOrderAdditionalFieldInfoForReceive(additionalFieldInfoData) {
              return additionalFieldInfoData
            },
            getCtgryNames(order) {
              let ret = ''
              if (order.ctgrys && order.ctgrys.length > 0) {
                for (let i = 0; i < order.ctgrys.length; i++) {
                  if (!ret && ret.trim() !== '') {
                    ret += ', '
                  }
                  ret += this.$t(
                    'ctgry.nm.' + order.site.id + '.' + order.ctgrys[i].id
                  )
                }
              }
              return ret
            },
            showOrder(e, order) {
              e.preventDefault()
              e.stopPropagation()
              this.$eventHub.$emit('show-detail-order', {
                componentId: this.getMainComponentId(),
                order: order,
                groupId: template.groupId
              })
            },
            showOrderSlide(e, order) {
              e.preventDefault()
              e.stopPropagation()
              order.slideOpen = true
              $('.slide-detail[order-id=' + order.id + ']').slideDown()
            },
            hideReceiveModal(e, order) {
              e.preventDefault()
              e.stopPropagation()

              $('.receive-order-area[order-id=' + order.id + ']').fadeOut(
                400,
                'linear',
                () => {
                  order.receiveModalOpened = false
                  $('html').css('overflow', this.oldHtmlOverflowCss)
                }
              )
            },
            hideOrderSlide(e, order) {
              e.preventDefault()
              e.stopPropagation()
              order.slideOpen = false
              $('.slide-detail[order-id=' + order.id + ']').slideUp()
            },
            toggleOrderSlide(e, order) {
              if (order.slideOpen) {
                this.hideOrderSlide(e, order)
              } else {
                this.showOrderSlide(e, order)
              }
            }
          }
        )
      } else if (template.name === 'stipulation-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            agree(successCb, failCb) {
              const agreed = []
              const disagreed = []
              let cont = true
              $('.stipulation-agreement').each(function() {
                if (
                  $(this).val() &&
                  !$(this).prop('checked') &&
                  $(this).attr('required')
                ) {
                  cont = false
                  return
                }
                if ($(this).val() && $(this).prop('checked')) {
                  agreed.push(parseInt($(this).val()))
                } else if ($(this).val() && !$(this).prop('checked')) {
                  disagreed.push(parseInt($(this).val()))
                }
              })
              if (cont) {
                window.setCookie('agreedStipulations', agreed)
                window.setCookie('disagreedStipulations', disagreed)
                if (successCb) {
                  successCb()
                }
                this.$router.push('/registration')
              } else if (failCb) {
                failCb()
              } else {
                this.$toast.error(
                  this.$t('stipulation.warning.required_is_missing')
                )
              }
            },
            agreeAll() {
              $('.stipulation-agreement').each(function() {
                $(this).prop('checked', true)
              })
            },
            agreeAllCheck(e) {
              $('.stipulation-agreement').each(function() {
                if ($(e.target).prop('checked')) {
                  $(this).prop('checked', true)
                } else {
                  $(this).prop('checked', false)
                }
              })
            }
          }
        )
      } else if (template.name === 'login-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            showForgotPasswordModal: function() {
              this.$refs.forgotPasswordModal.userId = ''
              this.$refs.forgotPasswordModal.showModal('modalRef')
            },
            onPressEnterOnPassword(e, p1, p2) {
              if (e && e.keyCode === 13) {
                this.login(p1, p2)
              }
            },
            login: function(usernameSelector, passwordSelector) {
              let username = ''
              $(usernameSelector).each(function() {
                if ($(this).attr('type') !== 'radio') {
                  username = $(this).val()
                }
              })
              this.$auth
                .loginWith('jwt', {
                  data: {
                    userId: username,
                    userPwd: $(passwordSelector).val(),
                    siteId: process.env.siteId
                  }
                })
                .then(response => {
                  if (window._loadedPushToken && window._onPushTokenLoaded) {
                    window._onPushTokenLoaded(window._loadedPushToken)
                  }
                  this.$router.replace('/')
                  window._eventHub.$emit('onEndRequest', {
                    dont_hide_processing: false,
                    url: 'signIn'
                  })
                  if (this.isCouponTicketUser()) {
                    this.openLink('/offline_meeting_ticket')
                  }
                })
                .catch(error => {
                  window._eventHub.$emit('onEndRequest', {
                    dont_hide_processing: false,
                    url: 'signIn'
                  })

                  if (
                    error.response &&
                    error.response.data &&
                    error.response.data.resultCode &&
                    error.response.data.resultCode === 'choose_name_for_same_id'
                  ) {
                    this.$eventHub.$emit('showChooseUserModal', {
                      userId: username,
                      userPwd: $(passwordSelector).val(),
                      action: 'login'
                    })
                  }
                  if (error.response && error.response.data) {
                    if (
                      error.response.data.resultCode === 'password_expired_1'
                    ) {
                      window._eventHub.$emit('showChangePasswordModal', {
                        userId: $(usernameSelector).val()
                      })
                    }
                  }
                })
            }
          }
        )
      } else if (template.name === 'player-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            isCurrentComposition(composition) {
              if (
                composition.id ===
                parseInt(this.$route.query.goodsCompositionId)
              ) {
                return true
              }
              return false
            },
            getComposition() {
              if (this.goods && this.goods.compositions) {
                for (let i = 0; i < this.goods.compositions.length; i++) {
                  const composition = this.goods.compositions[i]
                  if (
                    composition.id ===
                    parseInt(this.$route.query.goodsCompositionId)
                  ) {
                    if (
                      !(
                        this.loggedInUser &&
                        (this.isSeller(this.goods.sellers, this.loggedInUser) ||
                          this.isUploader(
                            this.goods.rgsOperId,
                            this.loggedInUser
                          ))
                      ) &&
                      !composition.atnlc
                    ) {
                      return {}
                    }
                    return composition
                  }
                }
              }
              return {}
            },
            showComposition(composition) {
              const query = {}
              for (const key in this.$route.query) {
                query[key] = this.$route.query[key]
              }
              query.goodsCompositionId = composition.id
              if (composition.atnlc) {
                query.atnlcCompositionId = composition.atnlc.id
              }
              this.$router.push({
                path: this.$router.currentRoute.path,
                query: query
              })
              this.showPlayer = false
              this.$nextTick(() => {
                this.showPlayer = true
                this.$forceUpdate()
                $('.player-container').animate(
                  {
                    scrollTop: '0px'
                  },
                  200
                )

                this.$eventHub.$emit('video-changed', {
                  componentId: this.getMainComponentId(),
                  composition: composition,
                  groupId: template.groupId
                })
              })
            }
          }
        )
      } else if (template.name === 'search-control') {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            searchKeyword() {
              if (!this.keyword) {
                this.$toast.error(this.$t('validation.error.keyword'))
                return
              }
              this.$router.push('/search?q=' + this.keyword)
              this.keyword = ''
              $(this.$el)
                .closest('.open')
                .each(function() {
                  $(this).removeClass('open')
                })
            }
          }
        )
      }
      if (
        template.name === 'more-items-control' ||
        template.name === 'items-pagination-control' ||
        template.name === 'no-items-display' ||
        template.name === 'load-on-scroll'
      ) {
        newVueComponentParam.methods = Object.assign(
          newVueComponentParam.methods,
          {
            onItemsPageInfoLoaded(params) {
              if (!params) {
                return
              }
              if (this.isSameGroupOrComponent(params, template)) {
                this.totalSize = params.totalSize

                if (template.name === 'no-items-display') {
                  if (this.totalSize === 0) {
                    if (
                      $(this.$el)
                        .get(0)
                        .tagName.toLowerCase() === 'tr'
                    ) {
                      $(this.$el).css('display', 'table-row')
                    } else {
                      $(this.$el).css('display', 'block')
                    }
                    $(this.$el).addClass('has-no-data')
                    $(this.$el).removeClass('has-data')
                    this.hasData = false
                  } else {
                    $(this.$el).css('display', 'none')
                    $(this.$el).addClass('has-data')
                    $(this.$el).removeClass('has-no-data')
                    this.hasData = true
                  }
                }
                this.currentPageNo = params.pageNo
                this.totalPageNo = params.totalPageNo
                this.loadedSize = params.loadedSize
                this.createPages()
              }
            },
            onItemsLoaded(params) {
              if (this.isSameGroupOrComponent(params, template)) {
                this.lastId = params.lastId
                this.totalSize = params.totalSize
                this.loadedSize = params.loadedSize
                if (template.name === 'no-items-display') {
                  if (this.totalSize === 0) {
                    if (
                      $(this.$el)
                        .get(0)
                        .tagName.toLowerCase() === 'tr'
                    ) {
                      $(this.$el).css('display', 'table-row')
                    } else {
                      $(this.$el).css('display', 'block')
                    }
                    $(this.$el).removeClass('has-data')
                    this.hasData = false
                  } else {
                    $(this.$el).css('display', 'none')
                    $(this.$el).addClass('has-data')
                    this.hasData = true
                  }
                }
                this.currentPageNo = params.pageNo
                this.totalPageNo = params.totalPageNo
                this.createPages()
                if (window.onEvent['items-loaded']) {
                  this.$nextTick(() => {
                    window.onEvent['items-loaded'](params)
                  })
                }
              }
            },
            createPages() {
              this.pages = []
              this.minPageNo = this.currentPageNo - this.diff
              this.maxPageNo = this.currentPageNo + this.diff
              if (this.minPageNo < 1) {
                this.minPageNo = 1
              }
              if (this.totalPageNo < this.maxPageNo) {
                this.maxPageNo = this.totalPageNo
              }
              for (let i = this.minPageNo; i <= this.maxPageNo; i++) {
                this.pages.push(i)
              }
            }
          }
        )
      }
      let param = newVueComponentParam
      if (window._templateComponents[template.name]) {
        window._templateComponents[template.name].data = param.data
        if (window._templateComponents[template.name].methods) {
          param.methods = Object.assign(
            param.methods,
            window._templateComponents[template.name].methods
          )
          window._templateComponents[template.name].methods = param.methods
        }
        if (window._templateComponents[template.name].components) {
          param.components = Object.assign(
            param.components,
            window._templateComponents[template.name].components
          )
          window._templateComponents[template.name].components =
            param.components
        }
        param = Object.assign(param, window._templateComponents[template.name])
      }
      return Vue.extend(param)
    }
  }
})
